import React from "react";
import { Link } from "react-router-dom";
import { calendar, calendarMonths, heroImages } from "../data/mock";
import { PageHero, Reveal, CTASection } from "../components/common";
import { Button } from "../components/ui/button";
import Seo from "../components/Seo";

const cell = { P: "bg-[#f5a524] text-[#0a1f33]", G: "bg-[#0e9488] text-white", O: "bg-white/5 text-slate-600" };

const FishingCalendar = () => (
  <>
    <Seo
      title="Nicaragua Fishing Season Calendar — San Juan del Sur | Hog Tide"
      description="Month-by-month fishing calendar for San Juan del Sur, Nicaragua. See peak seasons for sailfish, marlin, tuna, dorado, wahoo & roosterfish and plan your trip."
      path="/fishing-calendar"
    />
    <PageHero image={heroImages[4].img} eyebrow="Fish Season Calendar" title="Month-by-Month Fishing Guide" sub="Plan your trip around peak species activity. Every month offers excellent fishing in San Juan del Sur — use this chart to target the exact fish you want." />
    <section className="py-14">
      <div className="container-x">
        <Reveal>
          <div className="overflow-x-auto rounded-2xl border border-white/10 bg-[#0e2740]">
            <table className="w-full min-w-[760px] border-collapse">
              <thead>
                <tr className="bg-[#071726]">
                  <th className="text-left px-4 py-3 font-heading text-white sticky left-0 bg-[#071726] z-10">Species</th>
                  {calendarMonths.map((m) => (<th key={m} className="px-2 py-3 text-xs font-heading text-slate-300 text-center">{m}</th>))}
                </tr>
              </thead>
              <tbody>
                {calendar.map((r, ri) => r.group ? (
                  <tr key={ri} className="bg-[#123a5c]"><td colSpan={13} className="px-4 py-2 font-heading text-[#f5a524] text-sm uppercase tracking-wide">{r.group}</td></tr>
                ) : (
                  <tr key={ri} className="border-t border-white/5 hover:bg-white/5">
                    <td className="px-4 py-2.5 text-sm text-slate-100 font-medium sticky left-0 bg-[#0e2740]">{r.name}</td>
                    {r.m.map((v, i) => (<td key={i} className="px-1.5 py-2.5"><div className={`rounded-md text-center text-[11px] font-semibold py-1.5 ${cell[v]}`}>{v}</div></td>))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex flex-wrap gap-5 mt-4 text-sm text-slate-300">
            <span className="flex items-center gap-2"><span className="h-4 w-6 rounded bg-[#f5a524]" /> Peak — best action</span>
            <span className="flex items-center gap-2"><span className="h-4 w-6 rounded bg-[#0e9488]" /> Good — available</span>
            <span className="flex items-center gap-2"><span className="h-4 w-6 rounded bg-white/10" /> Off — limited</span>
          </div>
          <p className="text-xs text-slate-500 mt-4 max-w-3xl">All species are available year-round in San Juan del Sur. Peak seasons indicate the highest probability of encounters and best conditions — not the only time the species can be caught.</p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-4 mt-12">
          {[["Dec – Apr","Sailfish Season","Blue water, calm seas and the highest concentrations of sailfish of the year. Multiple hookups per trip are the norm."],["May – Sep","Marlin & Tuna Season","The green season brings blue & black marlin plus massive yellowfin tuna, mahi-mahi and wahoo. The biggest fish of the year."],["May – Oct","Inshore Peak","The best roosterfish action of the year along the beaches and rocky points. Cubera snapper and jacks fire too."]].map(([p,t,d])=>(
            <div key={t} className="rounded-2xl border border-white/10 bg-[#0e2740] p-6"><span className="text-[#f5a524] font-heading text-sm">{p}</span><h3 className="font-heading text-2xl text-white mt-1">{t}</h3><p className="text-sm text-slate-300 mt-2">{d}</p></div>
          ))}
        </div>
        <div className="text-center mt-10"><Link to="/plan-your-trip"><Button className="btn-gold h-12 px-8">Plan your trip around the season</Button></Link></div>
      </div>
    </section>
    <CTASection image={heroImages[1].img} />
  </>
);

export default FishingCalendar;
